export enum WarehouseReleaseListAction {
  Create,
}
